"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { useEffect, useRef, useState } from "react";
interface VehicleCard {
  id: number;
  className: string;
  image: string;
  name: string;
}
export default function OurPremiumVehicleSelection() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const [ripples, setRipples] = useState<{
    x: number;
    y: number;
    id: number;
  }[]>([]);
  const rippleIdRef = useRef(0);
  const vehicles: VehicleCard[] = [{
    id: 1,
    className: "Luxury Sedan",
    image: "https://present-gnat.10web.cloud/wp-content/uploads/2025/11/Stellar-Black-Metallic-e1762639298375.jpg",
    name: "Cadillac CT6"
  }, {
    id: 2,
    className: "Luxury Sedan",
    image: "https://present-gnat.10web.cloud/wp-content/uploads/2025/11/2021-volvo-s90-t6-awd-inscription-angular-front-exterior-view_100846451_l-e1752202292144.jpg",
    name: "Volvo S90"
  }, {
    id: 3,
    className: "Luxury Sedan",
    image: "https://present-gnat.10web.cloud/wp-content/uploads/2025/11/ext_GB8_deg02.jpg",
    name: "Cadillac XT6"
  }, {
    id: 4,
    className: "Full-Size SUV",
    image: "https://present-gnat.10web.cloud/wp-content/uploads/2025/11/image.jpg",
    name: "Chevrolet Suburban"
  }, {
    id: 5,
    className: "Full-Size SUV",
    image: "https://present-gnat.10web.cloud/wp-content/uploads/2025/11/image-1.jpg",
    name: "GMC Yukon XL"
  }, {
    id: 6,
    className: "Luxury SUV",
    image: "https://present-gnat.10web.cloud/wp-content/uploads/2025/11/2025_cadillac_escalade-esv_sport_032_gba-e1752202740841.png",
    name: "Cadillac Escalade"
  }];
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const newRipple = {
      x,
      y,
      id: rippleIdRef.current++
    };
    setRipples(prev => [...prev, newRipple]);
    setTimeout(() => {
      setRipples(prev => prev.filter(r => r.id !== newRipple.id));
    }, 800);
  };
  return <section ref={sectionRef} className="relative bg-secondary py-16 px-4 sm:px-6 lg:px-8 overflow-hidden" onMouseMove={handleMouseMove}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-display font-bold text-foreground-secondary mb-4">
            Our Premium Vehicle Selection
          </h2>
          <p className="text-lg text-muted-dark max-w-2xl mx-auto">Choose from our meticulously maintained fleet of luxury sedans and SUVs for your impeccable journey</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 relative">
          {vehicles.map((vehicle, i) => <Card key={vehicle.id} data-index={i} className={`group relative overflow-hidden bg-secondary shadow-[0_2px_4px_rgba(0,0,0,0.08)] hover:shadow-[0_6px_12px_rgba(0,0,0,0.12)] transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1.5 ${isVisible ? "animate-fade-in-up" : "opacity-0"}`} style={{
          animationDelay: `${i * 150}ms`
        }}>
              <div className="relative overflow-hidden bg-muted-light/5">
                <img src={vehicle.image} alt={vehicle.name} className="w-full aspect-[16/9] object-contain transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-primary/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-[var(--duration-medium)]" />
              </div>

              <CardContent className="relative pt-6 pb-6">
                <div className="absolute left-0 top-0 w-1 h-0 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:h-full" />
                <p className="text-sm font-medium text-accent mb-2">{vehicle.className}</p>
                <h3 className="text-xl font-display font-semibold text-foreground-secondary group-hover:text-accent transition-colors duration-[var(--duration-medium)]">
                  {vehicle.name}
                </h3>
              </CardContent>
            </Card>)}
        </div>
      </div>

      {ripples.map(ripple => <div key={ripple.id} className="pointer-events-none absolute rounded-full bg-muted/10 animate-ping" style={{
      left: ripple.x,
      top: ripple.y,
      width: "40px",
      height: "40px",
      transform: "translate(-50%, -50%)",
      animationDuration: "800ms"
    }} />)}
    </section>;
}